'use client';

import type { MouseEvent, Ref } from 'react';

import { ButtonContent, buttonClasses } from './ButtonContent';
import type { ButtonLinkProps } from './ButtonLink.types';

export function ButtonLink({
  style,
  children,
  className,
  suffixIcon,
  prefixIcon,
  variant = 'primary',
  size = 'md',
  shadow = false,
  disabled = false,
  loading = false,
  testId = 'ui-button-link',
  href,
  onClick,
  tabIndex,
  ref,
  ...rest
}: ButtonLinkProps & { ref?: Ref<HTMLAnchorElement> }) {
  const inactive = disabled || loading;

  return (
    <a
      {...rest}
      ref={ref}
      style={style}
      className={buttonClasses({
        variant,
        size,
        shadow,
        disabled,
        loading,
        className,
      })}
      href={inactive ? undefined : href}
      tabIndex={inactive ? -1 : tabIndex}
      aria-disabled={inactive || undefined}
      data-testid={testId}
      onClick={
        inactive
          ? (event: MouseEvent<HTMLAnchorElement>) => event.preventDefault()
          : onClick
      }
    >
      <ButtonContent
        prefixIcon={prefixIcon}
        suffixIcon={suffixIcon}
        loading={loading}
        testId={testId}
      >
        {children}
      </ButtonContent>
    </a>
  );
}
